import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

interface SafeIconProps extends React.SVGProps<SVGSVGElement> {
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

const SafeIcon: React.FC<SafeIconProps> = ({ icon, ...svgProps }) => {
  const IconComponent = icon || FiAlertTriangle;
  return React.createElement(IconComponent, svgProps);
};

export default SafeIcon;